import { render, staticRenderFns } from "./styleSettings.vue?vue&type=template&id=3cd1a8bc&scoped=true"
import script from "./styleSettings.vue?vue&type=script&lang=js"
export * from "./styleSettings.vue?vue&type=script&lang=js"
import style0 from "./styleSettings.vue?vue&type=style&index=0&id=3cd1a8bc&prod&lang=scss"
import style1 from "./styleSettings.vue?vue&type=style&index=1&id=3cd1a8bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd1a8bc",
  null
  
)

export default component.exports